import React from 'react';
import styled from 'styled-components';

import { ModalPosition, Container, Button, Checkbox, Label } from 'ui/components/styled';
import { ConfirmationModal } from 'ui/components/styled/NewModal/ConfirmationModal';

export const ConfirmUnarchive = ({ params, title, checkboxProps, ...rest }) => {
  const [checked, setChecked] = React.useState(checkboxProps?.checked || false);

  return (
    <ConfirmationModal
      padding="1.5rem 2rem 1.6rem"
      content={ModalContent}
      contentProps={{
        params,
        title,
        checkboxProps: { ...checkboxProps, checked },
        onCheckboxChange: setChecked,
      }}
      position={ModalPosition.TOP_CENTER}
      top="25%"
      width="45%"
      maxWidth="680px"
      {...rest}
    />
  );
};

const ModalContent = ({
  title,
  checkboxProps,
  onCheckboxChange,
  onClose,
  onConfirm,
  preventConfirm,
}) => {
  const handleCheckboxChange = (event) => {
    const { checked } = event.target;
    if (onCheckboxChange) {
      onCheckboxChange(checked);
    }
  };

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm({ checked: checkboxProps.checked });
    }
  };

  return (
    <>
      <>
        <Title mb="s">{title || 'Unarchive'}</Title>
        <Content mb="l">
          <Checkbox
            label={checkboxProps?.label || 'Would you like to match orphans?'}
            fontSize="14px"
            checked={checkboxProps.checked}
            onChange={handleCheckboxChange}
          />
          <Label variant="legend" mt="xs">
            This operation may take a significant amount of time (depending on the number of
            orphans).
          </Label>
        </Content>
      </>
      <Container flexDirection="row" justifyContent="flex-end">
        <Button variant="contrast-primary" width="35%" boxShadow="none" onClick={onClose} mr="m">
          Cancel
        </Button>
        <Button
          variant={checkboxProps.checked ? 'danger' : 'primary'}
          width="35%"
          boxShadow="none"
          onClick={handleConfirm}
          disabled={preventConfirm}
        >
          Proceed
        </Button>
      </Container>
    </>
  );
};

const Title = styled(Container)`
  font-weight: 500;
  font-size: 15px;
  letter-spacing: 0.04em;
  line-height: 26px;
  letter-spacing: 0.04em;
  color: #333;
`;

const Content = styled(Container)`
  font-weight: normal;
  font-size: 14px;
  letter-spacing: 0.04em;
  line-height: 26px;
  letter-spacing: 0.04em;
  color: #f74c4c;
`;
